<script lang="ts">
 export let sticker_nanoid: string;
</script>
<div class="flex bg-primary-100 rounded-xl justify-center items-center mb-2 ">
    <p class=" px-6 py-3 text-base font-medium tracking-wide text-primary-500">
        {sticker_nanoid}
    </p>

</div>